export default "__VITE_ASSET__Csu08B2W__"